module.exports = __webpack_public_path__ + "static/media/bettr-tasks.b92ff54e.png";